import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { dateSwitch, skipSet } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
import { activityDate2Human } from '../../utils/dateTime';
import ListSwitch from './ListSwitch';
import { get } from '../../hooks/api';
//
// Вспомогательный компонент для отображения фильтра по датам активностей
//
const FilterDate = ({ event }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const filter = useSelector(state => state.filter);
    const [ dates, setDates ] = useState([]);
    const [ listClass, setListClass ] = useState('list-open');

    // При смене мероприятия, надо обновить список
    useEffect(() => {
        const fetchDates = async (event_id) => {
            const result = await get(`/dates/${event_id}`);
            // Оставим только те дни, в которых число участников больше нуля
            setDates(result.data ? (result.data.dates ? result.data.dates.filter(d => d.count > 0) : []) : []);
        }
        fetchDates(event._id);
    }, [ event ]);

    const onSwitch = (date) => {
        dispatch(dateSwitch(date));
        dispatch(skipSet(0));
    };

    // В мероприятии нет дат, поэтому показывать не надо
    if(dates.length < 1) return null;

    return (            
        <React.Fragment>
        <ListSwitch title='filter.date' setListClass={setListClass} border={true}/>
        <div className={listClass}>
        {dates.map((date, index) => (
            <div
                key={index}
                onClick={() => onSwitch(date.date)}
                className={filter.dates.indexOf(date.date) < 0 ? 'item' : 'item check'}
            >
                <span className='icon'>
                    <FontAwesomeIcon
                        icon={filter.dates.indexOf(date.date) < 0 ? faSquare : faSquareCheck}
                    />
                </span>
                <div className='text'>
                    {activityDate2Human(date.date, lang, false)}&nbsp;
                    <small style={{color:'var(--gray-color)'}}>
                        ({date.count})
                    </small>
                </div>
            </div>
        ))}        
        </div>
        </React.Fragment>
    );
};

export default FilterDate;
